export const stringToNumber = (str?: string | number) => (typeof str === 'string' && +str ? +str : str) as number;